module.exports = __webpack_public_path__ + "img/copy_filled_32.9da3f158.svg";